import { TextField, Box, useTheme, useMediaQuery, Button } from '@mui/material'

import { Icons } from '../../../assets'
import texts from '../../texts'

interface SingleInputFormProps {
  name: string
  value: string
  onChangeValue: (value: string) => void
  placeholder: string
  onSubmit: React.FormEventHandler<HTMLFormElement>
  startAdornment: React.ReactNode
  endAdornment: React.ReactNode
}

const SingleInputForm = ({
  name,
  value,
  onChangeValue,
  placeholder,
  onSubmit,
  startAdornment,
  endAdornment,
}: SingleInputFormProps) => {
  const theme = useTheme()
  const widerThanTablet = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Box id='p-single-input-form' component='form' onSubmit={onSubmit}>
      <TextField
        id={name}
        name={name}
        className='singleInputForm'
        fullWidth
        value={value}
        onChangeCapture={(e) =>
          onChangeValue((e.target as HTMLInputElement).value)
        }
        placeholder={placeholder}
        InputProps={{
          startAdornment,
          endAdornment,
        }}
      />
      <Button
        id='p-single-input-form-button'
        size='small'
        color='primary'
        type='submit'
        className='singleInputForm'
      >
        {widerThanTablet ? (
          texts.searchAction
        ) : (
          <Icons.Search color='neutral.darkest' />
        )}
      </Button>
    </Box>
  )
}

export default SingleInputForm
